<p-panel [showHeader]="false">
  <canvas id="floor-main"></canvas>
</p-panel>
